<template>
  <div class="pfaq">
    <h3>Questions fréquentes sur le {{ productTitle }}</h3>
    <div class="pfaq__qas">
      <template v-for="(qa,i) in qas">
        <p class="pfaq__qestion" @click="toggleVisible(i)">
          <Triangle :rotate="replyVisible.includes(i)" :size="12"/>
          {{ qa.question }}
        </p>
        <p class="pfaq__reply" v-show="replyVisible.includes(i)">{{ qa.reply }}</p>
      </template>
      <hr>
    </div>
    <div v-show="sent">
      <p class="pfaq__sent">
        <CheckMarkAnimation :size="50" :trigger="sent"/>
        Merci, votre question a bien été envoyée.
      </p>
    </div>
    <div v-show="!sent">
      <p class="pfaq__ask">
        <QuestionAnswer/>
        (Nouveau) Posez votre question, notre équipe y répondra dans les meilleurs délais.
      </p>
      <form :class="{'sending': sending}" ref="form">
        <InputArea ref="question" rows="3" id="faq-question" :value.sync="question" required minlength="30">Votre question</InputArea>
        <button v-show="!showDetailsFields" type="button" @click="ask">DEMANDER</button>
        <div v-show="showDetailsFields && !userLoggedIn">
          <p><em>Vous avez un compte go2roues ? <a href="/mon-compte/">Connectez-vous &#x2192;</a></em></p>
          <fieldset>
            <legend>Vos informations sont collectées pour vous répondre et ne seront pas publiées</legend>
            <GridAutoColumns>
              <InputText id="faq-fn" :value.sync="first_name" :required="fieldsRequired">Votre Prénom</InputText>
              <InputText id="faq-ln" :value.sync="last_name" :required="fieldsRequired">Votre Nom</InputText>
            </GridAutoColumns>
            <GridAutoColumns>
              <InputEmail id="faq-email" :value.sync="from_email" :required="fieldsRequired">Votre email</InputEmail>
              <InputTel id="faq-tel" :value.sync="phone" :required="fieldsRequired">Votre téléphone</InputTel>
            </GridAutoColumns>
            <div class="pfaq__submit">
              <button type="button" @click="send">{{ sendText }}
                <Loader4 v-show="sending"/>
              </button>
            </div>
          </fieldset>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import InputEmail from "../partials/InputEmail";
import InputArea from "../partials/InputArea";
import CheckMarkAnimation from "../../../components/partials/CheckMarkAnimation";
import Loader4 from "../../../components/icons/Loader4";
import QuestionAnswer from "../../../components/icons/QuestionAnswer";
import TriangleLeft from "../../../components/icons/TriangleLeft";
import TriangleRight from "../../../components/icons/TriangleRight";
import InputText from "../partials/InputText";
import GridAutoColumns from "../../../components/partials/layout/GridAutoColumns";
import InputTel from "../partials/InputTel";
import Triangle from "../../../components/icons/Triangle";

export default {
  name: "ProductFAQ",
  components: {
    Triangle,
    InputTel,
    GridAutoColumns,
    InputText,
    TriangleRight, TriangleLeft, QuestionAnswer, Loader4, CheckMarkAnimation, InputArea, InputEmail
  },
  data() {
    return {
      qas: [],
      question: '',
      sending: false,
      sent: false,
      product_id: parseInt(g2rObj.postId),
      showDetailsFields: false,
      user_id: null,
      first_name: '',
      last_name: '',
      from_email: '',
      phone: '',
      replyVisible: [], //can't use Set(), reactivity issue
    }
  },
  computed: {
    productTitle() {
      return document.querySelector('h1.product_title').innerHTML
    },
    sendText() {
      if (this.sending) {
        return 'ENVOI'
      }
      return 'ENVOYER';
    },
    userLoggedIn() {
      return g2rObj.hasOwnProperty('userId')
    },
    fieldsRequired() {
      return this.showDetailsFields && !this.userLoggedIn
    },
  },
  methods: {
    toggleVisible(i) {
      if (this.replyVisible.includes(i)) {
        this.replyVisible = this.replyVisible.filter(item => item !== i)
      } else {
        this.replyVisible.push(i);
      }
    },
    showReply(i) {
      console.log(this.replyVisible)
      return this.replyVisible.has(i)
    },
    ask() {
      if (this.$refs.question.$el.children[1].checkValidity()) {
        if (this.userLoggedIn) {
          this.send()
        } else {
          this.showDetailsFields = true
        }
      } else {
        this.$refs.question.$el.children[1].reportValidity();
      }
    },
    send() {
      if (this.$refs.form.checkValidity()) {
        if (!this.sending) {
          this.sending = true;
          this.$api.post(`g2r/v1/product-faq`, this.$data)
            .then(response => response.data)
            .then(data => {
              if (Number.isInteger(data)) {
                this.sent = true
              } else {
                alert(`Un problème a empêché l'envoi de votre question.`)
              }
            })
            .finally(() => this.sending = false)
        }
      } else {
        this.$refs.form.reportValidity()
      }
    },
  },
  beforeMount() {
    this.qas = JSON.parse(document.getElementById('vue-product-faq-data').innerHTML)
  },
  mounted() {
    if (this.userLoggedIn) {
      this.user_id = parseInt(g2rObj.userId)
    }
  },
}
</script>

<style scoped lang="scss">
.pfaq {
  margin-bottom: 3rem;

  h4 {
    margin-top: 0;
  }

  .pfaq__qas {
    p {
      margin-bottom: 1rem;

      &.pfaq__qestion {
        cursor: pointer;
        text-decoration: underline;
        display: flex;
        align-items: center;
        svg {
          margin-right: .5rem;
        }
      }

      &.pfaq__reply {
        background-color: white;
        border-radius: .5rem;
        padding: 1rem 2rem;
      }
    }
  }

  .pfaq__sent {
    display: flex;
    align-items: center;

    svg {
      margin-right: 1rem;
    }
  }

  .pfaq__ask {
    display: flex;
    align-items: center;
    border-top: 1px solid var(--dark-blue);
    padding-top: 1rem;
    margin: 1rem auto;

    svg {
      margin-right: .5rem;
    }
  }

  form {
    transition: opacity .15s;

    &.sending {
      opacity: .3;
    }

    //::v-deep div:first-child {
    //  max-width: 500px;
    //}

    .pfaq__submit {
      display: flex;
      justify-content: flex-end;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;

        svg {
          margin-left: 1rem;
        }
      }
    }
  }
}

</style>
